import { FC } from 'react';
import { Target } from 'lucide-react';
import { FOCUS_PILL_CHROME } from './focusPillChrome';

interface FocusIndicatorBadgeProps {
  /** Visible label, which is also the accessible name. */
  label?: string;
  className?: string;
}

const BADGE_CLASS =
  `${FOCUS_PILL_CHROME} ` +
  'tw-relative tw-inline-flex tw-items-center tw-justify-center tw-gap-2 ' +
  'tw-border-2 tw-border-b-4 tw-border-solid tw-border-indigo-350 ' +
  'tw-px-4 tw-py-1 tw-text-sm tw-leading-5';

/**
 * The static "MY NEW FOCUS" pill (Figma node 2402:84996) shown in the US-7
 * first-focus modal. The animated persistent indicator on unit cards is a
 * separate component (AnimatedFocusPill).
 */
export const FocusIndicatorBadge: FC<FocusIndicatorBadgeProps> = ({ label = 'MY NEW FOCUS', className }) => (
  <span className={className ? `${BADGE_CLASS} ${className}` : BADGE_CLASS}>
    <Target size={16} aria-hidden />
    {label}
  </span>
);

export default FocusIndicatorBadge;
